import styled from 'styled-components/macro';

const Button = styled.button`
  color: ${({ theme }) => theme.colors.black};
`;

export default Button;
